import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Dealer.DeleteFile.IRequest;
type Response = Api.Core.Dealer.DeleteFile.IResponse;
type Headers = Api.Core.Dealer.DeleteFile.IHeaders;
const apiDealerDeleteFilePath = '/api/DealerManagement/Dealer/:id/DeleteFile/:fileId';
export default async function dealerDeleteFileApi(id: number, request: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    body: request,
    url: createPathFromRoute(apiDealerDeleteFilePath, { id, fileId: request.fileId }),
    method: HttpMethod.delete,
    headers: getDefaultHeaders(),
  });
}
